import React from "react";
import { NavLink } from "react-router-dom";
import logo from "../assets/logo.png";

const Header = () => {
  return (
    <header className="site-header">
      <div className="container header-inner">
        <div className="brand">
          <img src={logo} alt="Wellness Minds logo" className="brand-logo" />
          <div className="brand-text">
            <span className="brand-name">WELLNESSMINDS</span>
            <span className="brand-tagline">Mental wellness, gently supported</span>
          </div>
        </div>
        <nav className="nav" aria-label="Main navigation">
          <NavLink to="/" end className="nav-link">
            Home
          </NavLink>
          <NavLink to="/about" className="nav-link">
            About
          </NavLink>
          <NavLink to="/contact" className="nav-link">
            Contact
          </NavLink>
        </nav>
      </div>
    </header>
  );
};

export default Header;
